<button
	mat-flat-button
	type="button"
	class="w-100 search-button"
	(click)="triggerSearch()"
	color="{{ selectedOption && !open ? btnColor : '' }}"
	[ngClass]="{'filter-button-alt': !selectedOption && !disabled}"
	[disabled]="disabled"
	#selectButton
>
	<div class="title" [ngClass]="{'d-none': open || selectedOption}" i18n>
		<mat-icon
			matTooltip="{{tooltip}}"
			class="mr-2 align-middle"
			*ngIf="tooltip"
		>info</mat-icon>
		<span>{{ title ? title : 'Please Select' }}</span>
		<mat-icon class="ml-2 arrow-icon">keyboard_arrow_down</mat-icon>
	</div>
	<div class="title title--selected" *ngIf="!open && selectedOption" title="{{selectedOption?.name}}">
		<ng-container *ngFor="let meta of selectedOption?.meta | keyvalue: comparator">
			<span
				*ngIf="meta.value?.selected"
				class="badge badge-pill badge-info mr-2 py-1 px-2 align-middle {{meta.value?.class ? meta.value.class : ''}}"
				[ngClass]="{'text-capitalize': !meta.value?.preserveCase }"
			>{{ (meta.value?.preserveCase ? meta.value.name : meta.value.name.toLowerCase()) | i18nString: meta.value?.i18nKey }}</span>
		</ng-container>
		<span class="title__name">{{selectedOption.name}}</span>
		<mat-icon class="ml-2 arrow-icon">keyboard_arrow_down</mat-icon>
	</div>
	<ng-container *ngIf="open">
		<mat-form-field appearance="standard" class="search-input w-100 mat-suffix-click-through" dense>
			<input
				type="text"
				matInput
				[formControl]="searchControl"
				[matAutocomplete]="searchSelectAutoComplete"
				#searchInput
				placeholder="{{ placeholder ? placeholder : 'Search' }}"
				i18n-placeholder
				(blur)="closeSearch()"
				(keydown.escape)="inputBlur()"
				(keyup.space)="handleSpaceEvent($event)"
				(keydown.enter)="inputBlur()"
			>
			<mat-autocomplete #searchSelectAutoComplete="matAutocomplete" panelWidth="auto" (optionSelected)="optionSelected($event)" (closed)="searchClosed()">
				<mat-option *ngFor="let item of filteredData | async" [value]="item.id" class="{{item.id}}">
					{{item.name}}
					<div>
						<ng-container *ngFor="let meta of item.meta | keyvalue: comparator">
							<span
								*ngIf="!meta.value?.hide && !meta.value?.copyable"
								class="badge badge-pill badge-info mt-1 mr-2 py-1 px-2 {{meta.value?.class ? meta.value.class : ''}}"
								[ngClass]="{'text-capitalize': !meta.value?.preserveCase }"
							>{{ (meta.value?.preserveCase ? meta.value.name : meta.value.name.toLowerCase()) | i18nString: meta.value?.i18nKey }}</span>

							<button
								i18n-title
								*ngIf="!meta.value?.hide && meta.value?.copyable"
								class="btn badge badge-pill badge-info mt-2 mr-2 py-1 px-2 {{meta.value?.class ? meta.value.class : ''}} border-0"
								[ngClass]="{'text-capitalize': !meta.value?.preserveCase }"
								[appCopyToClipboard]="meta.value.name"
								[appCopyToClipboardIcon]="true"
								(click)="$event.preventDefault(); $event.stopPropagation();"
								appCopyToClipboardVisibility="none"
								i18n-title
								title="Click to copy to clipboard"
							>{{ (meta.value?.preserveCase ? meta.value.name : meta.value.name.toLowerCase()) | i18nString: meta.value?.i18nKey }}</button>

						</ng-container>
					</div>
				</mat-option>
			</mat-autocomplete>
		</mat-form-field>
	</ng-container>
</button>
